import * as React from 'react';
import { ListItem } from '../ListItem';
import { getDescription } from '../../utils/folders';
import { UIText2 } from '@cian/ui-kit';
import * as styles from './List.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function List(_ref) {
  var folders = _ref.folders,
    selectedIds = _ref.selectedIds,
    showLoadMoreButton = _ref.showLoadMoreButton,
    onChangeFolder = _ref.onChangeFolder,
    onLoadMoreButtonClick = _ref.onLoadMoreButtonClick;
  return /*#__PURE__*/_jsxs("div", {
    children: [folders.map(function (folder) {
      return /*#__PURE__*/_jsx(ListItem, {
        id: folder.id,
        name: folder.name,
        imageUrl: folder.imageUrl,
        description: getDescription(folder.offersCount),
        selected: Boolean(selectedIds[folder.id]),
        onChange: onChangeFolder
      }, folder.id);
    }), showLoadMoreButton && /*#__PURE__*/_jsx("button", {
      className: styles['more-button'],
      onClick: onLoadMoreButtonClick,
      children: /*#__PURE__*/_jsx(UIText2, {
        color: "text-main-default",
        fontWeight: "bold",
        children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0451"
      })
    })]
  });
}